
{
  "fr": {
    "buttonLabel": "Payer et valider"
  }
}
